import styled from "styled-components";
import { Box } from '@mui/material';

const BoxAlert = styled(Box)`
    background-color: #EFEDE8;
    border: 1px solid #CD8200;
    border-radius: 10px;
    padding: 12px 16px;
    display: flex;
    width: fit-content;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
    margin-top: 14px;
`;

const Text = styled.p`
    margin: 0;
    color: black;
    font-size: 14px;
    font-weight: 500;
`;

export default function AlertBox({ label, style }) {
    return (
        <BoxAlert style={{...style}}>
            <img
                src="/img/alert.svg"
                alt="Alerta"
                width={16}
                height={16}
                style={{ filter: 'brightness(0) saturate(100%) invert(57%) sepia(14%) saturate(1847%) hue-rotate(359deg) brightness(94%) contrast(87%)' }}
            />
            <Text>
                {label}
            </Text>
        </BoxAlert>
    );
}
